import { render } from "./Success.vue?vue&type=template&id=af2c4176"
const script = {}

import "./Success.vue?vue&type=style&index=0&id=af2c4176&lang=css"

import exportComponent from "/projects/inxure-hub/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__